export default __webpack_public_path__ + "static/media/homepage-bottom-1-optimized.40c44f63.jpg";